export type EditorRow = {
  id: string
  name?: string
  props?: any
  columns: {
    id: string
    span: number
    modules: any[]
  }[]
}

export function mapPublishedSectionsToRows(sections: any[] = []): EditorRow[] {
  if (!Array.isArray(sections)) return []

  return sections.map((section: any, sIndex: number) => {
    const hasRealColumns =
      Array.isArray(section?.columns) &&
      section.columns.length > 0 &&
      section.columns.some((c: any) => Array.isArray(c?.modules))

    const columns = hasRealColumns
      ? section.columns.map((col: any, cIndex: number) => ({
          id: String(col?.id ?? `col-${section?.id ?? `s-${sIndex}`}-${cIndex}`),
          span: Number(col?.span ?? 12) || 12,
          modules: (Array.isArray(col?.modules) ? col.modules : [])
            .slice()
            .sort((a: any, b: any) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0))
            .map((mod: any, mIndex: number) => ({
              id: String(mod?.id ?? crypto.randomUUID()),
              type: mod?.type,
              data: mod?.data ?? {},
              status: mod?.status ?? 1,
              sortOrder: mod?.sortOrder ?? mIndex,
            })),
        }))
      : [
          {
            id: `col-${section?.id ?? `s-${sIndex}`}-0`,
            span: 12,
            modules: (Array.isArray(section?.blocks) ? section.blocks : [])
              .slice()
              .sort((a: any, b: any) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0))
              .map((block: any, bIndex: number) => ({
                id: String(block?.id ?? crypto.randomUUID()),
                type: block?.type,
                data: block?.data ?? {},
                status: block?.status ?? 1,
                sortOrder: block?.sortOrder ?? bIndex,
              })),
          },
        ]

    // ✅ Defaults de props para que no venga undefined
    const DEFAULT_PROPS = {
      backgroundColor: 'auto',
      backgroundColorValue: '',
      backgroundGradient: '',
      backgroundImage: '',
    }

    return {
      id: String(section?.id ?? crypto.randomUUID()),
      name: section?.name ?? `Sección ${sIndex + 1}`,                 // ✅
      props: { ...DEFAULT_PROPS, ...(section?.props || {}) },         // ✅
      columns,
    }
  })
}

